const SubmitType = {
  GET_PO_BY_DEVORDER_SUPPLIER: 'GET_PO_BY_DEVORDER_SUPPLIER',
  GET_BULK_FILTERED_POS: 'GET_BULK_FILTERED_POS',
  SUBMIT_DOWNLOAD_LOG: 'SUBMIT_DOWNLOAD_LOG',
  DOWNLOAD_LOG: 'DOWNLOAD_LOG',
};

export default SubmitType;
